// plugins/eventsMixin.client.js
import { defineNuxtPlugin } from '#app';

export const eventMixin = {
    created() {
        if (!this.$options.events) return;

        this._boundEventHandlers = {};

        Object.entries(this.$options.events).forEach(([event, handler]) => {
            const bound = handler.bind(this);
            this._boundEventHandlers[event] = bound;
            this.$events.on(event, bound);
        });
    },

    beforeUnmount() {
        if (!this._boundEventHandlers) return;

        Object.entries(this._boundEventHandlers).forEach(([event, bound]) => {
            this.$events.off(event, bound);
        });
    }
};

export default defineNuxtPlugin(nuxtApp => {
    nuxtApp.vueApp.mixin(eventMixin);
});
